import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ea5471c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "down_box flex justify" }
const _hoisted_2 = { class: "down_left" }
const _hoisted_3 = { class: "down_right" }
const _hoisted_4 = { class: "establish_table flex justify" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "下载", -1))
const _hoisted_6 = { centered: "" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "删除", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "box_left" }
const _hoisted_10 = { class: "mod_pagin establish_pagation" }

import Crumb from '@/components/Crumb.vue';
import moment from 'moment';
import { computed, reactive, ref, unref } from 'vue';
import { Input, Table, Button, Popover, Pagination, Modal, DatePicker, message } from 'ant-design-vue';
import { useRoute } from 'vue-router';
import { SearchOutlined } from '@ant-design/icons-vue';
import { DownloadOutlined } from '@ant-design/icons-vue';
import { useDebounceFn } from '@vueuse/core'; //防抖
import http from '@/api';
import { ColumnProps } from 'ant-design-vue/es/table/interface';
import CDelModal from '@/components/CDelModal.vue';
import { SelectTypes } from 'ant-design-vue/es/select';
import { onExport } from '@/components/CExport'; //导出
import { getCurrentInstance } from 'vue';
import { getToken } from '@/plugins/cookie';
import router from '@/router';
import EventBus from '@/components/EventBus';
import { emptyDataSec } from '@/assets';

type Key = ColumnProps['key'];
interface DataType {
  key: number;
  id: number;
  file_name: string;
  created_at: string;
  status: string;
  studio_name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DownCenter',
  setup(__props) {

const { RangePicker } = DatePicker;
const aRangePicker = RangePicker;
const aInputSearch = Input.Search;
const aTable = Table;
const aPopover = Popover;
const aModal = Modal;
const aPagination = Pagination;

const route = useRoute();
const btnSize = ref('middle');
const showLoading = ref<boolean>(false);
const visible = ref<boolean>(false);
const modalVisible = ref(false);
const downloadLink = ref('');
const datafol = ref<DataType[]>([]);
const dataInfo = ref<DataType[]>([]);
const typeSort = ref();
const downDelId = ref();
const checked_all = ref(false);

const ranges: any = {
  今天: [moment().startOf('day'), moment().endOf('day')],
  最近一周: [moment().startOf('day').subtract(1, 'weeks'), moment()],
  最近一月: [moment().startOf('day').subtract(1, 'months'), moment()],
  最近三月: [moment().startOf('day').subtract(3, 'months'), moment()],
};
const Options = ref<SelectTypes['options']>([
  { value: '', label: '全部' },
  { value: 0, label: '下载中' },
  { value: 1, label: '下载成功' },
  { value: 2, label: '下载失败' },
]);

const queryForm = reactive<any>({
  keywords: '',
  liveDate: [],
  sub_studio: 0,
  selectOption: '',
});
//表格头
const columns = [
  {
    title: '任务ID',
    dataIndex: 'id',
    width: '20%',
    align: 'center',
  },
  {
    title: '直播间名称',
    dataIndex: 'studio_name',
    width: '15%',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '活动名称',
    dataIndex: 'file_name',
    align: 'center',
    width: '15%',
    ellipsis: true,
    slots: {
      customRender: 'file_name',
    },
  },
  {
    title: '操作时间',
    dataIndex: 'created_at',
    width: '15%',
    align: 'center',
    ellipsis: true,
  },

  {
    title: '任务状态',
    dataIndex: 'status',
    width: '15%',
    align: 'center',
    slots: {
      customRender: 'status',
    },
  },
  {
    title: '操作',
    dataIndex: 'portalHandle',
    width: '35%',
    align: 'center',
    slots: {
      customRender: 'portalHandle',
    },
  },
];
//表格数据
const downClick = () => {
  visible.value = true;
  downInfoList();
};

// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 1, // 总数
  options: ['12', '24', '36', '48', '60'], // 选项
});
const downPageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 1, // 总数
  options: ['12', '24', '36', '48', '60'], // 选项
});
const selectedRowKeys = ref<Key[]>([]);
selectedRowKeys.value = [];
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
  checked_all.value = selectedRowKeys.value.length == datafol.value.length ? true : false;
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});
EventBus.emit('watchNum');
const studioId = route.params.studioId;
// 获取用户下载列表
const downCenterList = useDebounceFn(() => {
  showLoading.value = true;
  checked_all.value = false;
  typeSort.value = 0;
  let data = {
    type: 0,
    keyword: queryForm.keywords,
    start_at: queryForm.liveDate[0] ? new Date(queryForm.liveDate[0]) : queryForm.liveDate[0],
    end_at: queryForm.liveDate[1] ? new Date(queryForm.liveDate[1]) : queryForm.liveDate[1],
    status: queryForm.selectOption,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
    studio_id: studioId,
  };
  http.dotCensus
    .userDownloadList({ params: data })
    .then((res) => {
      const degree = res.data.data.data;
      datafol.value = [...degree];
      showLoading.value = false;
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
    })
    .catch(() => {
      showLoading.value = false;
    });
});
downCenterList();
const downInfoList = useDebounceFn(() => {
  typeSort.value = 1;
  let data = {
    type: 1,
    page: downPageConfig.current,
    page_num: downPageConfig.pageSize,
    studio_id: studioId,
  };
  http.dotCensus
    .userDownloadList({ params: data })
    .then((res) => {
      const degree = res.data.data.data;
      dataInfo.value = [...degree];
      downPageConfig.current = res.data.data.current_page;
      downPageConfig.totalSize = res.data.data.total;
    })
    .catch(() => {
      message.error('获取失败');
    });
});

//弹框删除按钮
const openDelModat = () => {
  modalVisible.value = false;
  selectedRowKeys.value = [];
  checked_all.value = false;
};
//弹框确认按钮
const removeLiveData = useDebounceFn(() => {
  let delPortal = {
    id: typeSort.value == 1 ? downDelId.value : selectedRowKeys.value.join(','),
  };
  http.dotCensus
    .delDownloadInfo({ params: delPortal })
    .then((res) => {
      message.success(res.data.message);
      if (typeSort.value == 1) {
        downInfoList();
        downCenterList();
      } else if (typeSort.value == 0) {
        downCenterList();
      }
      checked_all.value = false;
      selectedRowKeys.value = [];
      modalVisible.value = false;
    })
    .catch((res: any) => {
      message.error(res.data.error);
      modalVisible.value = false;
    });
});
// 删除按钮
const openDelModal = useDebounceFn(() => {
  // id重复，清空数组
  let data: any = [];
  datafol.value.map((res) => {
    data.push(res.id);
  });
  modalVisible.value = true;
});
//表格删除按钮
const tabDel = (record: any) => {
  typeSort.value = 0;
  // 清空id
  selectedRowKeys.value = [];
  // 获取id
  selectedRowKeys.value.push(record.id);
  modalVisible.value = true;
};

// 表格下载按钮
const previewsImg = (record: any) => {
  downloadLink.value = record.download_link;
  window.location.href = record.download_link; //预览下载
};

const downDelClick = (id: number) => {
  modalVisible.value = true;
  downDelId.value = id;
  typeSort.value = 1;
};

// 全选
const setSelectAll = () => {
  typeSort.value = 0;
  if (checked_all.value) {
    let data: any = [];
    datafol.value.map((res) => {
      data.push(res.id);
    });
    onSelectChange([...data]);
  } else {
    onSelectChange([]);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(aRangePicker), {
          ranges: ranges,
          "show-time": { format: 'HH:mm' },
          format: "YYYY-MM-DD HH:mm",
          value: queryForm.liveDate,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.liveDate) = $event)),
          class: "mod_range_picker container_textLeft_picker right",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(downCenterList)())),
          onOk: _cache[2] || (_cache[2] = ($event: any) => (_unref(downCenterList)()))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_a_select, {
          class: "mod_select selected right",
          value: queryForm.selectOption,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.selectOption) = $event)),
          placeholder: "全部",
          options: Options.value,
          "show-search": "",
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_unref(downCenterList)())),
          defaultActiveFirstOption: ""
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_select_icon",
              "icon-class": "list_select"
            })
          ]),
          _: 1
        }, 8, ["value", "options"]),
        _createVNode(_unref(aInputSearch), {
          class: "mod_range_picker_search right",
          onSearch: _cache[5] || (_cache[5] = ($event: any) => (_unref(downCenterList)())),
          value: queryForm.keywords,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.keywords) = $event)),
          placeholder: "请输入关键字"
        }, {
          enterButton: _withCtx(() => [
            _createVNode(_unref(SearchOutlined))
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_a_button, {
          type: "primary",
          size: btnSize.value,
          onClick: downClick
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(DownloadOutlined))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 下载列表 ")
          ]),
          _: 1
        }, 8, ["size"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_checkbox, {
          class: "select",
          checked: checked_all.value,
          "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((checked_all).value = $event)),
          onChange: _cache[8] || (_cache[8] = ($event: any) => (setSelectAll()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("全选")
          ]),
          _: 1
        }, 8, ["checked"]),
        _createVNode(_component_a_button, {
          class: "mod_btn",
          type: "link",
          danger: "",
          disabled: selectedRowKeys.value.length == 0,
          onClick: _unref(openDelModal)
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_btn_icon",
              "icon-class": "del"
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 删除 ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(aTable), {
        loading: showLoading.value,
        columns: columns,
        "row-selection": _unref(rowSelection),
        "data-source": datafol.value,
        pagination: false,
        class: "liveList_w",
        rowKey: 
          (res) => {
            return res.id;
          }
        
      }, {
        portalHandle: _withCtx(({ record }) => [
          _createVNode(_unref(aPopover), {
            placement: "left",
            "arrow-point-at-center": ""
          }, {
            content: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _createElementVNode("a", _hoisted_6, [
                (record.status == '下载失败' || record.status == '下载中')
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "mod_btn",
                      type: "link",
                      danger: "",
                      disabled: record.status == '下载失败' || record.status == '下载中'
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          class: "liveList_out",
                          "icon-class": "downIcons"
                        })
                      ]),
                      _: 2
                    }, 1032, ["disabled"]))
                  : (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      class: "mod_btn svgIcon",
                      type: "link",
                      onClick: ($event: any) => (previewsImg(record))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          class: "liveList_out",
                          "icon-class": "downIcon"
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ])
            ]),
            _: 2
          }, 1024),
          _createVNode(_unref(aPopover), {
            placement: "left",
            "arrow-point-at-center": ""
          }, {
            content: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createElementVNode("a", {
                centered: "",
                onClick: ($event: any) => (tabDel(record))
              }, [
                _createVNode(_component_svg_icon, { "icon-class": "unionDel" })
              ], 8, _hoisted_8)
            ]),
            _: 2
          }, 1024)
        ]),
        status: _withCtx(({ record }) => [
          _createElementVNode("a", {
            style: _normalizeStyle({ color: record.status == '下载失败' ? '#a9a9a9' : record.status == '已完成' ? '#00ccb0' : '#ED9E01' })
          }, _toDisplayString(record.status), 5)
        ]),
        _: 1
      }, 8, ["loading", "row-selection", "data-source", "rowKey"])
    ]),
    _createVNode(_unref(aModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((visible).value = $event)),
      title: "下载列表",
      footer: "",
      class: "modal_page"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataInfo.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "modal_box flex align",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, _toDisplayString(item.file_name), 1)
            ]),
            _createVNode(_component_svg_icon, {
              "icon-class": "unionDel",
              class: "del_icon",
              onClick: ($event: any) => (downDelClick(item.id))
            }, null, 8, ["onClick"])
          ]))
        }), 128)),
        (dataInfo.value.length !== 0)
          ? (_openBlock(), _createBlock(_unref(aPagination), {
              key: 0,
              simple: "",
              total: downPageConfig.totalSize,
              current: downPageConfig.current,
              "onUpdate:current": _cache[9] || (_cache[9] = ($event: any) => ((downPageConfig.current) = $event)),
              "page-size": downPageConfig.pageSize,
              "onUpdate:pageSize": _cache[10] || (_cache[10] = ($event: any) => ((downPageConfig.pageSize) = $event)),
              pageSizeOptions: downPageConfig.options,
              onChange: _unref(downInfoList),
              onShowSizeChange: _unref(downInfoList)
            }, null, 8, ["total", "current", "page-size", "pageSizeOptions", "onChange", "onShowSizeChange"]))
          : _createCommentVNode("", true),
        (dataInfo.value.length === 0)
          ? (_openBlock(), _createBlock(_component_a_empty, {
              key: 1,
              class: "empty_wrap",
              image: _unref(emptyDataSec),
              description: "页面暂无数据信息~"
            }, null, 8, ["image"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", _hoisted_10, [
      (datafol.value.length !== 0)
        ? (_openBlock(), _createBlock(_unref(aPagination), {
            key: 0,
            "show-quick-jumper": "",
            total: pageConfig.totalSize,
            current: pageConfig.current,
            "onUpdate:current": _cache[12] || (_cache[12] = ($event: any) => ((pageConfig.current) = $event)),
            "page-size": pageConfig.pageSize,
            "onUpdate:pageSize": _cache[13] || (_cache[13] = ($event: any) => ((pageConfig.pageSize) = $event)),
            pageSizeOptions: pageConfig.options,
            "show-less-items": "",
            "show-size-changer": "",
            onChange: _unref(downCenterList),
            onShowSizeChange: _unref(downCenterList)
          }, null, 8, ["total", "current", "page-size", "pageSizeOptions", "onChange", "onShowSizeChange"]))
        : _createCommentVNode("", true),
      _createVNode(CDelModal, {
        visible: modalVisible.value,
        zIndex: 2001,
        centered: "",
        close: openDelModat,
        ok: _unref(removeLiveData),
        class: "del_modal"
      }, null, 8, ["visible", "ok"])
    ])
  ]))
}
}

})